import { create } from 'apisauce';
import { API_BASE_URL, API_BASE_URL_STAGING, PL_API_BASE_URL } from '../../../config/constants';


export default class BaseAPI {
  private services: any;

  constructor(services) {
    services.afterLoad(() => {
      // pass
    });

    this.services = services;
  }

  get authToken() {
    return this.services.authToken;
  }

  public route(action) {
    return action[0] === '/' ? action.slice(1) : action;
  }

  public getAPI(noAuth=false, useStaging=false) {
    // use env file that's not commitable to git instead of usestaging var
    const baseURL = PL_API_BASE_URL
    const api = create({
      baseURL,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    });

    if (!noAuth) {
      api.setHeader('Authorization', `Bearer ${this.authToken}`);
    }

    return api;
  }

  public get(action, noAuth) {
    const api = this.getAPI(noAuth);

    return api.get(this.route(action));
  }

  public delete(action, noAuth) {
    const api = this.getAPI(noAuth);
    return api.delete(this.route(action));
  }

  public post(action, data, noAuth) {
    const api = this.getAPI(noAuth);

    return api.post(this.route(action), data);
  }

  public put(action, data, noAuth) {
    const api = this.getAPI(noAuth);

    return api.put(this.route(action), data);
  }

  public patch(action, data, noAuth) {
    const api = this.getAPI(noAuth);

    return api.patch(this.route(action), data);
  }
}



// WEBPACK FOOTER //
// ./src/services/API/v1/Base.ts